import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AIEndpointIcon = props => (
  <Icon viewBox="0 0 721 721" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-576 -92)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M622 453 757 453"
                stroke="currentColor"
                strokeWidth="33.75"
                strokeLinecap="round"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
              />
              <path
                d="M757 363 847 363 847 543 757 543Z"
                stroke="currentColor"
                strokeWidth="33.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
              />
              <path
                d="M847 453 1027 453"
                stroke="currentColor"
                strokeWidth="33.75"
                strokeLinecap="round"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
              />
              <path
                d="M959.5 318 1072 318C1146.56 318 1207 378.442 1207 453 1207 527.558 1146.56 588 1072 588L959.5 588"
                stroke="currentColor"
                strokeWidth="33.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
              />
              <path
                d="M1094.5 453C1094.5 477.853 1074.35 498 1049.5 498 1024.65 498 1004.5 477.853 1004.5 453 1004.5 428.147 1024.65 408 1049.5 408 1074.35 408 1094.5 428.147 1094.5 453Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
